export class Translation {

  private static DEFAULT_LOCATION = "en"

  private translations: Record<string, string> = {}

  public static getLocationCode = (): string =>
    window.location.pathname.split("/")[1] || Translation.DEFAULT_LOCATION

  public fetchTranslations = async (id: string): Promise<void> => {
    try {
      const response = await fetch(`/api/v1/${Translation.getLocationCode()}/translation/${id}`)
      if (!response.ok) return
      this.translations = await response.json()
    } catch {
      // Ignore network errors; caller may retry later
    }
  }

  public isEmpty = (): boolean => Object.keys(this.translations).length === 0

  public t = (key: string): string => this.translations[key] ?? key
}
